import Component from '../abstracts/Component';

export default class StoreEventComponent extends Component {

  get SELECTORS() {
    return {
      citySelect: '.js-choose-city',
      storeSelect: '.js-choose-store',
      storeDiv: '.store-block',
      wrapperStoreEvent : '.js-store-event-module',
      wrapperStoreSelected : '.wrapper-select.show',
      formStoreEvent: 'js-store-event-form',
      checkboxGroup: '.checkboxes-group',
      inputEmail: '.js-email-input',
      privacy: '.js-wrapper-privacy',
    };
  }

  get CLASSES() {
    return {
      show: 'show'
    };
  }

  constructor() {
    super();
    this.main = $(this.SELECTORS.main);
  }

  bindEvents() {
    let ctx = this;
    let map = 'undefined';
    let iconMarker = $('#detail-map').data('iconMarker');

    $('body').on('change', '.js-choose-city' , function () {
      var selectedTown = $(this).val();

      //hide previous-show stores select
      let selectedStore = document.querySelector('.wrapper-select.show');
      if(selectedStore){
        selectedStore.classList.replace('show', 'd-none');
        selectedStore.querySelector('.js-choose-store').value = '';
        selectedStore.querySelector('.select2-selection__rendered').innerHTML = '';
      }

      //hide previous-show  event info
      let selectedEventInfo = document.querySelectorAll('.store-block:not(.d-none)');
      if(selectedEventInfo) {
        selectedEventInfo.forEach(function(info) {
          info.classList.replace('show','d-none');
          let inputs = info.querySelectorAll('input');
          inputs.forEach(function () {
            $(this).prop('disabled', true);
          });
        });
      }
      $('.wrapper-map-store-event').removeClass('showMap');
      $('.js-store-event-email-wrapper').addClass('d-none');

      //show stores for city selected
      let storeSelect = $('.js-choose-store[data-city="' + selectedTown + '"]');
      storeSelect.closest('.wrapper-select').removeClass('d-none').addClass('show');
    });

    $('body').on('change', '.js-choose-store' , function () {
      var selectedTown = $(this).data('city');
      var selectedStoreId = $(this).val();

      let selectedEventInfo = document.querySelectorAll('.store-block:not(.d-none)');
        if(selectedEventInfo) {
          selectedEventInfo.forEach(function(info) {
            info.classList.replace('show','d-none');
            let inputs = info.querySelectorAll('input');
            inputs.forEach(function () {
              $(this).prop('disabled', true);
            });
          });
        }

      $('.store-block[data-store-id="' + selectedStoreId + '"]').removeClass('d-none').addClass('show');
      $('.store-block[data-store-id="' + selectedStoreId + '"]').find('input[name=eventName]').prop('disabled',false);
      $('.store-block[data-store-id="' + selectedStoreId + '"]').find('input[name=eventDate]').prop('disabled',false);
      $('.store-block[data-store-id="' + selectedStoreId + '"]').find('input[name=eventTime]').prop('disabled',false);
      $('.store-block[data-store-id="' + selectedStoreId + '"]').find('input[name=storeId]').prop('disabled',false);

      $('.store-block[data-store-id!="' + selectedStoreId + '"]').find('input[name=eventName]').prop('disabled',true);
      $('.store-block[data-store-id!="' + selectedStoreId + '"]').find('input[name=eventDate]').prop('disabled',true);
      $('.store-block[data-store-id!="' + selectedStoreId + '"]').find('input[name=eventTime]').prop('disabled',true);
      $('.store-block[data-store-id!="' + selectedStoreId + '"]').find('input[name=storeId]').prop('disabled',true);

      $('.js-store-event-email-wrapper').removeClass('d-none');

      $('.wrapper-map-store-event').addClass('showMap');

      var storeLat = $('.store-block[data-store-id="' + selectedStoreId + '"]').data('latitude');
      var storeLng =  $('.store-block[data-store-id="' + selectedStoreId + '"]').data('longitude');
      var storeName =  $('.store-block[data-store-id="' + selectedStoreId + '"]').data('storeName');



      const _styles = [
        { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
        { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
        { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
        { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#bdbdbd' }],
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [{ color: '#eeeeee' }],
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#757575' }],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [{ color: '#e5e5e5' }],
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#9e9e9e' }],
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [{ color: '#ffffff' }],
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#757575' }],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [{ color: '#dadada' }],
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#616161' }],
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#9e9e9e' }],
        },
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [{ color: '#e5e5e5' }],
        },
        {
          featureType: 'transit.station',
          elementType: 'geometry',
          stylers: [{ color: '#eeeeee' }],
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{ color: '#c9c9c9' }],
        },
        {
          featureType: 'water',
          elementType: 'geometry.fill',
          stylers: [{ color: '#fcf6e7' }],
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#9e9e9e' }],
        },
      ];
      var mapOptions = {
        center: {lat: storeLat, lng: storeLng},
        zoom: 17,
        styles: _styles,
        disableDefaultUI: true,
        scaleControl: true,
        gestureHandling: 'cooperative'
      };
      map = new google.maps.Map(document.getElementById("detail-map"));
      map.setOptions(mapOptions);

      var image = {
        url: iconMarker,
        size: new google.maps.Size(44, 44),
        origin: new google.maps.Point(0, 0),
        scaledSize: new google.maps.Size(44, 44)
      };

      var marker = new google.maps.Marker({
        position: {lat: storeLat, lng: storeLng},
        map: map,
        title: storeName,
        icon: image
      });

      marker.setMap(map);
      map.setCenter({lat: storeLat, lng: storeLng});
    });

    $('body').on('submit','.js-store-event-form', function (e) {
      e.preventDefault();
      let  $form = $(this).serialize();

      $.ajax({
        url: '/action/ajax/store-event',
        type : 'POST',
        data : $form,
        success: function(result){
          $('.js-store-event-email-wrapper').append(result);
       }}
      );

    });


    $('body').on('focus.storeevent',ctx.SELECTORS.inputEmail, function (e) {
      let checkboxes = $(ctx.SELECTORS.checkboxGroup);
      checkboxes.addClass(ctx.CLASSES.show);
    });

    // force validation on change
    $('body').on('focusout.storeevent',ctx.SELECTORS.inputEmail, function (e) {
      document.newsletterBouncer.validate(this);
      const $email = $(this);
      ctx.updateSubmitButton($email);
    });

    $('body').on('click.storeeventprivacy',ctx.SELECTORS.privacy, function (e) {
      const $email = $(this);
      ctx.updateSubmitButton($email);
    });
  }

  updateSubmitButton ($email) {
    let emailHasError = $email.hasClass( "error" );
    let form = $email.closest('form');

    let $privacy = form.find(this.SELECTORS.privacy);
    let id = $privacy.attr('id');
    let basicNewsletterSubmit = document.querySelector('button[data-target="' + id + '"]');
    let checked = $privacy.is(':checked');

    if (checked && !emailHasError) {
      $(basicNewsletterSubmit).prop('disabled', false);
    } else {
      $(basicNewsletterSubmit).prop('disabled', true);
    }
  };

  render() {
    this.bindEvents();
  }
}
